const login = {
  login: {
    welcomeToCasinoBackOffice: 'Welcome to',
    casinoBackOffice: 'Casino Back Office',
    usernameOrEmail: 'Email',
    login: 'Login',
  },
}

export default login
